const safeFetch = async (url, options) => {
  try {
    const { body, ...otherOptions } = options;
    let stringBody = null;
    if (body) {
      if (body instanceof FormData) {
        delete otherOptions.headers['Content-Type'];
        stringBody = body;
      } else {
        stringBody = JSON.stringify(options.body);
      }
    }

    const response = await fetch(url, {
      body: stringBody,
      credentials: 'include',
      ...otherOptions,
      headers: {
        ...options.headers,
      },
    });
    if (response.ok) {
      const type = response.headers.get('Content-Type');
      let data = null;
      if (options.responseType === 'arraybuffer') {
        data = await response.arrayBuffer();
        const imageBlob = new Blob([data], { type });
        const urlCreator = window.URL || window.webkitURL;
        data = urlCreator.createObjectURL(imageBlob);
      } else {
        try {
          data = await response.json();
        } catch (e) {
          return;
        }
      }
      return { data };
    } else if ([401, 403].includes(response.status)) {
      const result = await response.json();
      const error = Error(`API Error ${response.status}`);
      error.status = response.status;
      error.data = result?.data ?? { message: 'В доступе отказано' };
      throw error;
    } else if (response.status === 400 && response.url.includes('account/credentials/password')) {
      throw new Error(400);
    } else {
      throw new Error('error fetch');
    }
  } catch (error) {
    throw error;
  }
};

export default safeFetch;
